import { mapActions } from "vuex";

export default  {
	methods: 
    {
		...mapActions({			
			saveAll: 'crudStore/saveAll',
		}),
		async saveForm(event)
		{
			try{
				if(event.ftn!==undefined)
				{
					switch(event.ftn)
					{
						case 'pacienteNuevoFtn':
							await this.updateDataPost({ 
								data: { 
									data: [],
									route: 'save_paciente', 
									tablaPost: ['datos_pacientes']
								 }
							 })
						break;
						case 'guardarFtn':
							await this.updateDataPost({ 
								data: { 
									data: [],
									route: 'save_examen', 
									tablaPost: ['datos_pacientes','info_examens','examen_antecedentes','examen_diagnosticos','examen_pruebas']
								 }
							 }) 
							 await this.updateDataForm({state: 'info_examens/antiguo', data: 1})
						break;
					}
				}
				await this.save(event.save)	
				if(event.ftn!==undefined)
				{
					switch(event.ftn)
					{
						case 'guardarFtn':							
								this.resetCrud({state: 'searchSw/value'})
								this.resetDataForm()
								this.active=0
							break;
						case 'pacienteNuevoFtn':
							let busqueda= this.gettersDatalist('datos_pacientes',this.dataForm[this.namePath].datos_pacientes.name)
							await this.updateCrud({state:'swSearchs/datos_pacientes', data: busqueda[0]})
							await this.updateCrud({state:'searchSw/value', data: this.swSearchs.datos_pacientes.id})
							await this.resetGlobal({state: 'openModal'})
							await this.updateDataForm({state:'datos_pacientes', data: this.swSearchs.datos_pacientes})
						break;

					}
				}	
				
				return true
			}
			catch{

			}			
		}		
	},
}
